import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, isRef as _isRef, unref as _unref, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/img/contactUs/kf-ico.png'
import _imports_1 from '../assets/img/contactUs/kf-ico1.png'
import _imports_2 from '../assets/img/contactUs/kf-ico2.png'
import _imports_3 from '../assets/img/contactUs/toright.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-1a9670a2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  class: "kf-ico"
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "kf-text" }, "联系我们", -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = { class: "infobox" }
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div class=\"info-text1\" data-v-1a9670a2>客服咨询</div><div class=\"info-row\" data-v-1a9670a2><img src=\"" + _imports_1 + "\" alt=\"\" class=\"kf-ico1\" data-v-1a9670a2><div class=\"dhbox\" data-v-1a9670a2><div class=\"info-text2\" data-v-1a9670a2>电话热线</div><div class=\"info-text3\" data-v-1a9670a2>400 666 6011</div></div></div><div class=\"kbbox\" data-v-1a9670a2></div><div class=\"info-text1\" data-v-1a9670a2>技术咨询</div><div class=\"info-row\" data-v-1a9670a2><img src=\"" + _imports_2 + "\" alt=\"\" class=\"kf-ico1\" data-v-1a9670a2><div class=\"dhbox\" data-v-1a9670a2><div class=\"info-text2\" data-v-1a9670a2>许经理</div><div class=\"info-text3\" data-v-1a9670a2>1590 126 5905</div></div></div>", 5)
const _hoisted_11 = [
  _hoisted_6
]
const _hoisted_12 = {
  src: _imports_3,
  alt: "",
  class: "toright"
}
const _hoisted_13 = { class: "content" }

import { defineComponent, onMounted, ref, reactive } from 'vue';
import myheader from './header.vue'
import mybottom from './bottom.vue'

import type { ComponentSize, FormInstance, FormRules } from 'element-plus'
import {
  CircleCheckFilled,
} from '@element-plus/icons-vue'
import tmMitt from "../utils/tmMitt.ts";
import { getcode, addUser } from '../utils/axios'
import { ElMessage } from 'element-plus'
import { isMobile } from '../utils/validate'


// tmMitt.on("openinfo", (data) => {
//   console.log("openinfo", data);
//   showRegister.value = true
//   ruleForm.value.registrationType = data.type
// });



export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

let showus = ref(false)





onMounted(() => {
  // ElMessage({
  //   duration:0,
  //   showClose: true,
  //   message: 'Congrats, this is a success message.',
  //   type: 'success',
  // })

})







return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(myheader),
    _createElementVNode("div", {
      class: "contactUs",
      onMouseenter: _cache[0] || (_cache[0] = ($event: any) => (_isRef(showus) //@ts-ignore
 ? showus.value = true : showus = true)),
      onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (_isRef(showus) //@ts-ignore
 ? showus.value = false : showus = false))
    }, _hoisted_4, 32),
    _withDirectives(_createElementVNode("div", _hoisted_5, _hoisted_11, 512), [
      [_vShow, _unref(showus)]
    ]),
    _withDirectives(_createElementVNode("img", _hoisted_12, null, 512), [
      [_vShow, _unref(showus)]
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", null, [
        _createVNode(_component_router_view)
      ])
    ]),
    _createVNode(mybottom, { class: "bottombox" })
  ]))
}
}

})